/**
 * product-card-size-picker.js
 *
 * Desktop: seleciona o tamanho e o botao "Adicionar a sacola" envia ao carrinho.
 * Mobile: icone na foto abre bottom sheet; Confirmar adiciona a variante.
 */
(function () {
  'use strict';

  var PICKER_SELECTOR = '[data-product-card-size-picker]';
  var SHEET_SELECTOR = '[data-size-sheet]';
  var SIZE_SELECTOR = '[data-variant-id]';
  var OPEN_CLASS = 'is-open';
  var BODY_CLASS = 'product-card-size-sheet-open';
  var mobileQuery = window.matchMedia('(max-width: 767.98px)');
  var openSheetEl = null;
  var openTriggerEl = null;
  var lastOpenAt = 0;

  function isMobile() {
    return mobileQuery.matches;
  }

  function isUnavailable(el) {
    return (
      !el ||
      el.hasAttribute('no-available') ||
      el.hasAttribute('disabled') ||
      el.getAttribute('aria-disabled') === 'true' ||
      el.disabled === true
    );
  }

  function getForm(productForm) {
    if (!productForm) return null;
    return (
      productForm.querySelector('form[data-type="add-to-cart-form"]') ||
      productForm.querySelector('form')
    );
  }

  function submitForm(productForm, form) {
    if (productForm && typeof productForm.handleFormSubmit === 'function') {
      productForm.handleFormSubmit({
        preventDefault: function () {},
        target: form
      });
      return;
    }

    try {
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit();
        return;
      }
    } catch (err) {
      /* fallback abaixo */
    }

    var submitEvent =
      typeof SubmitEvent === 'function'
        ? new SubmitEvent('submit', { bubbles: true, cancelable: true })
        : new Event('submit', { bubbles: true, cancelable: true });
    form.dispatchEvent(submitEvent);
  }

  function cssEscape(value) {
    if (value == null) return '';
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }
    return String(value).replace(/"/g, '\\"');
  }

  function findPicker(fromEl) {
    if (!fromEl || !fromEl.closest) return null;
    var picker = fromEl.closest(PICKER_SELECTOR);
    if (picker) return picker;

    var sheet = fromEl.closest(SHEET_SELECTOR);
    if (!sheet) return null;
    var id = sheet.getAttribute('data-picker-id');
    if (!id) return null;
    return document.querySelector(
      PICKER_SELECTOR + '[data-picker-id="' + cssEscape(id) + '"]'
    );
  }

  function getSheet(picker) {
    if (!picker) return null;
    var nested = picker.querySelector(SHEET_SELECTOR);
    if (nested) return nested;

    var id = picker.getAttribute('data-picker-id');
    if (!id) return null;
    return document.querySelector(
      SHEET_SELECTOR + '[data-picker-id="' + cssEscape(id) + '"]'
    );
  }

  function getTrigger(picker) {
    if (!picker) return null;
    return picker.querySelector('[data-size-sheet-open]');
  }

  function setTriggerOpen(trigger, isOpen) {
    if (!trigger) return;
    trigger.classList.toggle(OPEN_CLASS, isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function submitVariant(picker, variantId) {
    if (!picker || !variantId) return;
    var productForm = picker.querySelector('product-form');
    var form = getForm(productForm);
    if (!form) return;

    var input =
      form.querySelector('[data-product-form-variant]') ||
      form.querySelector('input[name="id"]');
    if (!input) return;

    input.value = variantId;
    submitForm(productForm, form);
  }

  function resetSheet(sheet) {
    if (!sheet) return;
    var sizes = sheet.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < sizes.length; i++) {
      sizes[i].classList.remove('is-selected');
      sizes[i].removeAttribute('aria-pressed');
    }
    sheet.removeAttribute('data-selected-variant');
    var confirm = sheet.querySelector('[data-size-sheet-confirm]');
    if (confirm) confirm.disabled = true;
  }

  function closeSheet() {
    if (!openSheetEl) return;

    var sheet = openSheetEl;
    var picker = findPicker(sheet);

    sheet.classList.remove(OPEN_CLASS);
    sheet.setAttribute('hidden', '');
    resetSheet(sheet);

    if (picker && sheet.parentElement !== picker) {
      picker.appendChild(sheet);
    }

    setTriggerOpen(openTriggerEl || getTrigger(picker), false);
    openSheetEl = null;
    openTriggerEl = null;
    document.body.classList.remove(BODY_CLASS);
  }

  function openSheet(picker) {
    if (!picker) return;
    var sheet = getSheet(picker);
    if (!sheet) return;

    var now = Date.now();
    if (openSheetEl === sheet && now - lastOpenAt < 400) return;
    lastOpenAt = now;

    if (openSheetEl && openSheetEl !== sheet) closeSheet();

    if (sheet.parentElement !== document.body) {
      document.body.appendChild(sheet);
    }

    resetSheet(sheet);
    sheet.removeAttribute('hidden');
    sheet.classList.add(OPEN_CLASS);
    openSheetEl = sheet;
    openTriggerEl = getTrigger(picker);
    setTriggerOpen(openTriggerEl, true);
    document.body.classList.add(BODY_CLASS);

    var panel = sheet.querySelector('.product-card-size-sheet__panel');
    if (panel && typeof panel.focus === 'function') {
      panel.setAttribute('tabindex', '-1');
      panel.focus({ preventScroll: true });
    }
  }

  function eventElement(event) {
    var target = event && event.target;
    if (!target) return null;
    if (target.nodeType === 3) return target.parentElement;
    if (typeof target.closest === 'function') return target;
    return target.parentElement;
  }

  function stopCardGesture(event) {
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function tryOpenFromEvent(event) {
    var target = eventElement(event);
    if (!target || typeof target.closest !== 'function') return false;
    var openEl = target.closest('[data-size-sheet-open]');
    if (!openEl) return false;
    stopCardGesture(event);
    openSheet(findPicker(openEl));
    return true;
  }

  function selectSize(scope, sizeEl) {
    if (!scope || isUnavailable(sizeEl)) return;
    var sizes = scope.querySelectorAll(SIZE_SELECTOR);
    for (var i = 0; i < sizes.length; i++) {
      sizes[i].classList.toggle('is-selected', sizes[i] === sizeEl);
      if (sizes[i] === sizeEl) {
        sizes[i].setAttribute('aria-pressed', 'true');
      } else {
        sizes[i].removeAttribute('aria-pressed');
      }
    }
    scope.setAttribute('data-selected-variant', sizeEl.getAttribute('data-variant-id'));
    var confirm = scope.querySelector('[data-size-sheet-confirm]');
    if (confirm) confirm.disabled = false;
  }

  function onPointerDown(event) {
    var target = eventElement(event);
    if (!target || typeof target.closest !== 'function') return;
    if (!target.closest('[data-size-sheet-open]')) return;
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  }

  function onPointerUp(event) {
    if (event.pointerType && event.button != null && event.button !== 0) return;
    tryOpenFromEvent(event);
  }

  function onClick(event) {
    var target = eventElement(event);
    if (!target || typeof target.closest !== 'function') return;

    if (tryOpenFromEvent(event)) return;

    var closeEl = target.closest('[data-size-sheet-close]');
    if (closeEl) {
      event.preventDefault();
      event.stopPropagation();
      closeSheet();
      return;
    }

    var confirmEl = target.closest('[data-size-sheet-confirm]');
    if (confirmEl) {
      event.preventDefault();
      event.stopPropagation();
      if (confirmEl.disabled) return;
      var sheet = confirmEl.closest(SHEET_SELECTOR);
      var picker = findPicker(confirmEl);
      var variantId = sheet && sheet.getAttribute('data-selected-variant');
      if (picker && variantId) submitVariant(picker, variantId);
      closeSheet();
      return;
    }

    var desktopAdd = target.closest('[data-desktop-add]');
    if (desktopAdd) {
      event.preventDefault();
      event.stopPropagation();
      var picker = findPicker(desktopAdd);
      var desktop = desktopAdd.closest('.product-card-size-picker__desktop');
      var variantId =
        (desktop && desktop.getAttribute('data-selected-variant')) ||
        (picker && picker.getAttribute('data-selected-variant'));
      if (picker && variantId) submitVariant(picker, variantId);
      return;
    }

    var sizeEl = target.closest(SIZE_SELECTOR);
    if (sizeEl) {
      var sheet = sizeEl.closest(SHEET_SELECTOR);
      if (sheet) {
        event.preventDefault();
        event.stopPropagation();
        selectSize(sheet, sizeEl);
        return;
      }

      var picker = sizeEl.closest(PICKER_SELECTOR);
      if (!picker) return;
      event.preventDefault();
      event.stopPropagation();
      if (isUnavailable(sizeEl)) return;
      if (isMobile()) return;
      var desktop = sizeEl.closest('.product-card-size-picker__desktop');
      selectSize(desktop || picker, sizeEl);
      if (desktop) picker.setAttribute('data-selected-variant', sizeEl.getAttribute('data-variant-id'));
      return;
    }

    var pickerClick = target.closest(PICKER_SELECTOR);
    if (pickerClick) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && openSheetEl) {
      event.preventDefault();
      closeSheet();
    }
  }

  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointerup', onPointerUp, true);
  document.addEventListener('click', onClick, true);
  document.addEventListener('keydown', onKeydown);

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', function () {
      if (!isMobile()) closeSheet();
    });
  }
})();
